import { Injectable } from "@angular/core";
import { DirectoryService } from "@app/core/services/directory.service";
import { ProfessionalSport } from "@app/shared/models";
import * as fromShared from "@app/shared/store";
import * as ProfessionalSportActions from "@app/shared/store/actions/professional-sport.actions";
import * as ProfessionalSportSelectors from "@app/shared/store/selectors/professional-sport.selectors";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

@Injectable()
export class ProfessionalSportEffects {
  loadProfessionalSportList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfessionalSportActions.loadProfessionalSportList),
      withLatestFrom(
        this.store$.pipe(
          select(ProfessionalSportSelectors.selectProfessionalSportList()),
        ),
      ),
      switchMap(([_, currentProfessionalSportList]) =>
        (currentProfessionalSportList.length
          ? of(currentProfessionalSportList)
          : this.directoryService
              .loadProfessionalSportList()
              .pipe(map((res) => res.data))
        ).pipe(
          map((list: ProfessionalSport[]) =>
            ProfessionalSportActions.loadProfessionalSportListSuccess({
              ProfessionalSportList: list,
            }),
          ),
          catchError((error) =>
            of(
              ProfessionalSportActions.loadProfessionalSportListFailure({
                error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store$: Store<fromShared.State>,
    private directoryService: DirectoryService,
  ) {}
}
